import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import MaintenanceAdd from './MaintenanceAdd.vue'
import MaintenanceEdit from './MaintenanceEdit.vue'
import MaintenanceDetail from './MaintenanceDetail'
import { MaintainProjectServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
const mpjsp = new MaintainProjectServiceProxy()
@Component({
  components: {
    MaintenanceAdd,
    MaintenanceDetail,
    MaintenanceEdit
  }
})
export default class Maintenance extends Vue { // 保养项目
  @Prop({ default: "" }) readonly deviceId
  @Prop({ default: () => ({}) }) readonly selectDevice: Object;

  @Watch('deviceId')
  getData() {
    this.reload()
  }

  created(){
    this.reload()
  }

  reload(){
    this.filters = {
      current: 1,
      size: 10
    }
    this.keywords = ""
    this.total = 0
    this.selectId = ""
    this.addVisible = false
    this.editVisible = false
    this.detailList = []
    this.getListPage()
  }

  getListPage(){
    this.loading = true
    mpjsp.queryMaintainProjectListPage(this.filters.current = 1,this.deviceId,this.filters.size).then(res =>{
      if(res){
        this.dataSource = res.records
        this.total = Number(res.total)
        this.loading = false
        if(this.selectId !== ""){
          this.clickRow(this.selectId)
        } else {
          console.log(res.records)
          this.selectId = res.records.length ? res.records[0].id : ''
          this.clickRow(this.selectId)
        }
      }
    })
  }

  edit(record) {
    mpjsp.queryMaintainProject(record.id).then(res =>{
      this.editData = res
      this.editVisible = true
    })
  }

  get columns() {
    return [
      {
        title: this.$t('page_tenant_operation'),
        key: 'action',
        fix: 'left',
        width: 80,
        customRender: (text, record) => {
          return (
            <div>
              <a-popconfirm
                title={this.$t('page_resource_pool_confirm_delete')}
                onConfirm={() => {
                  this.deleteSingleData(record.id)
                }}
                okText={this.$t('yes')}
                cancelText={this.$t('no')}
              >
                <a onClick={e => e.stopPropagation()} class="del-color" v-acl="page_business_delete_maintenance">
                  {this.$t('delete')}
                </a>
              </a-popconfirm>
              <a-divider type="vertical" />
              <a
                type="link"
                onClick={(e) => {
                  e.stopPropagation();
                  this.edit(record);
                }}
              >
                {this.$t("edit")}
              </a>
            </div>
          )
        }
      },
      { title: this.$t('page_plan_maintenance_maintenance_items_code'), dataIndex: 'code', width: 150, ellipsis: true },
      { title: this.$t('page_plan_maintenance_program'), dataIndex: 'name', width: 200, ellipsis: true },
      { title: this.$t('page_plan_maintenance_period'), dataIndex: 'intervalTime', width: 100, ellipsis: true },
      { title: this.$t('page_plan_maintenance_warning_days'), dataIndex: 'preWarningDays', width: 150, ellipsis: true },
      { title: this.$t('remark'), dataIndex: 'remark', width: 200, ellipsis: true }
    ]
  }

  filters = {
    current: 1,
    size: 10
  }
  keywords = ""
  total = 0
  loading = false
  dataSource = []
  addVisible = false
  selectId = ""
  detailLoading = false
  detailList = []
  editData = {}
  editVisible = false
  resizeTimer = null
  tableScrollHeight = 170

  deleteSingleData(id){
    mpjsp.deleteMaintainProject(id).then(res =>{
      this.$message.success(this.$t('delete_success'))
      this.reload()
    })
  }

  pageIndexchange(value){
    this.filters = {
      current: value,
      size: 10
    }
    this.selectId = ""
    this.getListPage()
  }

  addNew() {
    this.addVisible = true
  }

  showTotal(total) {
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  clickRow(id){
    this.selectId = id
    this.detailLoading = true
    mpjsp.queryMaintainProjectItemList(id).then(res =>{
      this.detailList = res
      this.detailLoading = false
    })
  }

  changeY(){
    if(this.resizeTimer){
      clearTimeout(this.resizeTimer);
    }
    this.resizeTimer = setTimeout(function(){
      const div = document.getElementById('ware-topmodal')
      this.tableScrollHeight = div.clientHeight
      const bodyTableBody: any = document.querySelector('#ware-topmodal .ant-table-body')
      if(bodyTableBody){
        bodyTableBody.style.maxHeight = (this.tableScrollHeight - 88) + 'px'
      }
    },100)
  }

  render() {
    return (
      <div style="height: 100%;padding-top: 8px;overflow-y: auto;">
        <a-button type="primary" style="margin-bottom:8px" onClick={() => this.addNew()}>{ this.$t('page_plan_maintenance_new_maintenance')}</a-button>
        <div style="height: 260px;overflow-y: auto;overflow-x: hidden;position: relative;">
          <ml-table
            size="small"
            rowKey="id"
            defaultExpandAllRows={true}
            canChangeColWidth={true}
            loading={this.loading}
            dataSource={this.dataSource}
            columns={this.columns}
            scroll={{ y: 170, x: 1030 }}
            selectRowKey={this.selectId}
            customRow={(record) => {
              return {
                on: { // 事件
                  click: () => this.clickRow(record.id),      // 点击行
                },
              };
            }}
          ></ml-table>
          <a-pagination
            style="position:absolute;bottom: 4px;right: 20px"
            total={this.total}
            pageSize={this.filters.size}
            current={this.filters.current}
            show-total={total => `${this.showTotal(total)}`}
            onChange={this.pageIndexchange}
            onShowSizeChange={this.pageIndexchange}
          ></a-pagination>
        </div>
        <div v-resize={{axis: 'y', cb: this.changeY }}></div>
        <div>
          <maintenance-detail
            loading={this.detailLoading}
            data={this.detailList}
          ></maintenance-detail>
        </div>
          {this.addVisible ?
            <maintenance-add
              deviceId={this.deviceId}
              selectDevice={ this.selectDevice }
              visible={this.addVisible}
              onClose={() => this.addVisible = false}
              onReload={() => this.reload()}
            ></maintenance-add>: null}
            {this.editVisible ?
              <maintenance-edit
                deviceId={this.deviceId}
                selectDevice={ this.selectDevice }
                editData={this.editData}
                visible={this.editVisible}
                onClose={() => this.editVisible = false}
                onReload={() => this.reload()}
              ></maintenance-edit>: null}
      </div>
    )
  }
}
